import { render, staticRenderFns } from "./NewUserPromoPromoBannerCompact.vue?vue&type=template&id=47b2d650&scoped=true"
import script from "./NewUserPromoPromoBannerCompact.vue?vue&type=script&lang=js"
export * from "./NewUserPromoPromoBannerCompact.vue?vue&type=script&lang=js"
import style0 from "./NewUserPromoPromoBannerCompact.vue?vue&type=style&index=0&id=47b2d650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2d650",
  null
  
)

export default component.exports